// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import makeModCalcTotals from './makeModCalcTotals'

// makes a 2d array of modulations calculations to display in a <DataTable />
const prepModulationsCalculations = pathEnd => {
  const {
    radio,
    radioModulationConfigurations,
    segmentEndCalculations: { modulationsCalculations },
  } = pathEnd

  // if modulationsCalculations === null, that means that the calculations
  // failed to even run. as such, just pass an empty array back so the UI
  // handles this scenario correctly.
  if (modulationsCalculations === null) {
    return []
  }

  // radio will be null if there's no radio assigned to this segment end
  // however, because RSL comes from the opposing segment end, we need to
  // still allow modulationsCalculations to be looped.
  const modulations = (
    radio
      ? radio.modulations
      : []
  )

  return modulationsCalculations.map((d, i) => (
    makeModCalcTotals(i, d, radioModulationConfigurations, modulations)
  ))
}

export default prepModulationsCalculations
